"use strict";
function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
__export(require("./window-container-api"));



//////////////////
// WEBPACK FOOTER
// /app/~/redi-window-container-web-lib/dist/business/index.js
// module id = 37
// module chunks = 0